var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('video',{ref:"local",attrs:{"autoplay":"","controls":""}}),_c('p',[_vm._v(_vm._s(_vm.info.type))])])}
var staticRenderFns = []

export { render, staticRenderFns }